window.CL_FRAC = {"/":{"d":[0,0,0.0156,0.2656,0.2656,0.7969,0.7969,0.3594,0.625,0.2969,0.9219,0.6719],"m":[0,0.0313,0.6406,0.8281,0.1875,0.125,0.1563,0.2969,0.9063,0.3906,0.3281,0.8906]},"/collections/culottes-femmes":{"d":[0,0,0.0469,0.7969],"m":[0,0.5938,0,0.5625]},"/products/lot-de-7-culottes-antibacteriennes-gris":{"d":[0,0.2813,0.7656,0.7656,0.3906,0.3906,0.3906,0.3906,0.8281,0.8438,0.7188,0.7813,0.5313],"m":[0,0.4219,0.0156,0.2344,0.6719,0.1719,0.9688,0.4688,0.25,0.0625,0.9375,0.5938,0.1563]},"/products/culotte-italienne-flora":{"d":[0,0.6875,0.0625,0.0781,0.9531,0.7344,0.4844],"m":[0,0.2969,0.3594,0.1719,0.0469,0.4219,0.9844]},"/products/culotte-italienne-maria":{"d":[0,0.6875,0.0625,0.0781,0.9531,0.7031,0.4531],"m":[0,0.9063,0.9688,0.7813,0.6563,0,0.5625]},"/products/boxer-homme-en-dentelle-antonio":{"d":[0,0.9219,0.2969,0.3125,0.1875,0.5,0.25],"m":[0,0.8594,0.9219,0.7344,0.6094,0.5156,0.0781]},"/products/boxer-homme-en-dentelle-alessandro":{"d":[0,0.9219,0.2969,0.3125,0.1875,0.5,0.25],"m":[0,0.6406,0.7031,0.5156,0.3906,0.4844,0.0469]},"/products/culottes-en-dentelle-isabella":{"d":[0,0.7031,0.5,0.3125,0.3125,0.8125,0,0.375,0.3906,0.6563,0.4063],"m":[0,0.4063,0.0313,0.2813,0.2969,0.7031,0.7813,0.8438,0.6563,0.5156,0.0781]},"/products/culottes-amincissantes-en-dentelle":{"d":[0,0.7031,0.7031,0.7031,0.7031,0.7031,0.0781,0.0938,0.9688,0.4219,0.1719],"m":[0,0.2344,0.9063,0.3125,0.1094,0.3125,0.375,0.1875,0.0625,0.4844,0.0469]},"/pages/contact":{"d":[0,0,0.5,0.25,0.9375,0.6875],"m":[0,0,0.1875,0.375,0.6875,0.25]},"/pages/a-propos-de-nous":{"d":[0,0,0,0,0,0.75],"m":[0,0.4375,0.9375,0.8125,0.875,0.4375]},"/products/lot-de-7-culottes-antibacteriennes-colors":{"d":[0,0.7656,0.25,0.25,0.875,0.875,0.875,0.875,0.3125,0.3281,0.2031,0.2656,0.0156],"m":[0,0.2813,0.875,0.0938,0.5313,0.0313,0.8281,0.3281,0.1094,0.9219,0.7969,0.4531,0.0156]}};
/* cl-orl.js — camada global das secoes copiadas do tema dele (Pipeline 8.1).
   - <video data-src> (lazyload dele): carrega e toca, mudo e em loop, ao entrar na tela
   - controles das secoes "video with text": play/pause e som (o markup dele, classe clx-active = ligado) */
(function () {
  'use strict';
  var SEC = '[class*="cl-sec-"]';
  function start(v) {
    if (!v.getAttribute('src') && v.getAttribute('data-src')) {
      v.src = v.getAttribute('data-src');
      v.removeAttribute('data-src');
    }
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('loop', '');
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  // video de tema servido SAME-origin (/cdn/shop/t/N/assets/...), como o dele (/cdn/shop/videos/...): o
  // congelamento de quadro do verify so funciona same-origin — com cdn.shopify.com o lado dele virava poster
  // e o nosso ficava <video> vivo (0.92 numa secao identica). Sem o fragmento #t que o dele nao tem.
  function sameOrigin(el) {
    var s = el.getAttribute('src') || '';
    var m = s.match(/^(?:https?:)?\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\/(t\/\d+\/assets\/[^#?]+)(\?[^#]*)?/);
    if (m) el.setAttribute('src', '/cdn/shop/' + m[1] + (m[2] || ''));
    else if (/#t=/.test(s)) el.setAttribute('src', s.replace(/#t=[^&]*$/, ''));
  }
  function videos() {
    var vs = [].slice.call(document.querySelectorAll(SEC + ' video'));
    if (!vs.length) return;
    vs.forEach(function (v) {
      var before = v.getAttribute('src');
      sameOrigin(v);
      [].forEach.call(v.querySelectorAll('source'), sameOrigin);
      if (v.getAttribute('src') !== before) v.load();
    });
    if (!('IntersectionObserver' in window)) { vs.forEach(start); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { start(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '300px 0px' });
    vs.forEach(function (v) { if (v.closest('[data-cl-no-autoplay]')) return; io.observe(v); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(SEC + ' [class*="video-with-text-play"], ' + SEC + ' [class*="video-with-text-sound"]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[class*="video-text-video"]') || b.parentElement.parentElement;
    var v = box && box.querySelector('video');
    if (!v) return;
    if (/video-with-text-play/.test(b.className)) {
      if (v.paused) { start(v); b.classList.add('clx-active'); } else { v.pause(); b.classList.remove('clx-active'); }
    } else {
      v.muted = !v.muted; b.classList.toggle('clx-active', !v.muted);
    }
  });
  /* ---- carrossel (flickity congelado pelo extract) das secoes duplas [data-cl-own] ----
     celulas ficam onde o flickity dele as pos (translateX(N%) de cada celula); a faixa anda
     por -x px. Setas .flickity-prev-next-button (da mesma .flickity-enabled), arrasto/toque. */
  function carousels() {
    document.querySelectorAll('[data-cl-own] .flickity-viewport').forEach(function (vp) {
      if (vp._clc || vp.closest('[data-cl-pdp]')) return;
      var slider = vp.querySelector('.flickity-slider');
      if (!slider) return;
      var cells = [].filter.call(slider.children, function (c) { return c.nodeType === 1; });
      if (cells.length < 2) return;
      vp._clc = 1;
      var box = vp.closest('.flickity-enabled') || vp.parentElement;
      var idx = 0;
      function geo() {
        var W = vp.clientWidth || vp.getBoundingClientRect().width;
        var cw = cells[0].getBoundingClientRect().width || W;
        var vis = Math.max(1, Math.floor(W / cw + 0.02));
        return { W: W, cw: cw, max: Math.max(0, cells.length - vis) };
      }
      function paint(anim) {
        var g = geo();
        if (!g.W) return;
        idx = Math.max(0, Math.min(idx, g.max));
        slider.style.transition = anim ? 'transform .45s ease' : 'none';
        slider.style.transform = 'translate3d(' + (-idx * g.cw) + 'px,0,0)';
        cells.forEach(function (c, i) { c.classList.toggle('is-selected', i === idx); c.setAttribute('aria-hidden', (i < idx || i >= idx + Math.round(g.W / g.cw)) ? 'true' : 'false'); });
        var pv = box.querySelector('.flickity-prev-next-button.previous'), nx = box.querySelector('.flickity-prev-next-button.next');
        if (pv) pv.disabled = idx <= 0;
        if (nx) nx.disabled = idx >= g.max;
      }
      function go(d) { idx += d; paint(true); }
      box.addEventListener('click', function (e) {
        var b = e.target.closest('.flickity-prev-next-button');
        if (!b || !box.contains(b)) return;
        e.preventDefault(); e.stopPropagation();
        go(b.classList.contains('next') ? 1 : -1);
      }, true);
      var sx = null, sy = null, moved = false;
      vp.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button) return; sx = e.clientX; sy = e.clientY; moved = false; });
      vp.addEventListener('pointermove', function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 8) moved = true; });
      vp.addEventListener('pointerup', function (e) {
        if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      });
      vp.addEventListener('pointercancel', function () { sx = null; });
      vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
      var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { paint(false); }, 100); });
      vp._clcPaint = paint;
      paint(false);
    });
  }
  /* ---- oi-slider (slider proprio do tema dele: avis, imagens das secoes "double") ----
     modo slide: faixa [data-oi-track] com clones nas pontas (loop), anda por translate3d;
     modo fade (.oi-slider--fade): troca .clx-is-active no slide. Setas data-oi-prev/next,
     pontos data-oi-dot, arrasto/toque, autoplay data-oi-interval (5s, como o dele). O extract
     congela o slider no meio do autoplay: aqui todo slider nasce no 1o slide real. */
  function oiSliders() {
    document.querySelectorAll('[data-cl-own] [data-oi-slider]').forEach(function (sl) {
      if (sl._oi) return; sl._oi = 1;
      var fade = sl.classList.contains('oi-slider--fade');
      var track = sl.querySelector('[data-oi-track]');
      var all = [].slice.call(sl.querySelectorAll('[data-oi-slide]'));
      var real = all.filter(function (s) { return !s.hasAttribute('data-oi-clone'); });
      if (!track || real.length < 2) return;
      var lead = all.indexOf(real[0]);
      var dots = [].slice.call(sl.querySelectorAll('[data-oi-dot]'));
      var loop = sl.getAttribute('data-oi-loop') === 'true';
      var idx = 0, timer = null;
      function pos(i, anim) {
        var el = all[lead + i] || real[0];
        track.style.transition = anim ? 'transform var(--OI-SLIDE-DURATION, 500ms) ease' : 'none';
        track.style.transform = 'translate3d(' + (-(el.offsetLeft - all[0].offsetLeft)) + 'px, 0px, 0px)';
      }
      function paint(anim) {
        if (fade) {
          real.forEach(function (s, i) { s.classList.toggle('clx-is-active', i === idx); s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
        } else {
          pos(idx, anim);
          real.forEach(function (s, i) { s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
        }
        dots.forEach(function (d, i) { d.classList.toggle('clx-is-active', i === idx); d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      }
      function go(i, user) {
        var n = real.length, to = i;
        if (!fade && loop && (i < 0 || i >= n)) {
          // anda ate o clone e volta, sem animacao, para o real equivalente
          var j = i < 0 ? -1 : n;
          pos(j, true);
          idx = (i + n) % n;
          dots.forEach(function (d, k) { d.classList.toggle('clx-is-active', k === idx); d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
          setTimeout(function () { pos(idx, false); }, 520);
        } else {
          idx = loop ? (to + n) % n : Math.max(0, Math.min(n - 1, to));
          paint(true);
        }
        if (user) restart();
      }
      function restart() {
        if (timer) clearInterval(timer);
        var iv = +sl.getAttribute('data-oi-interval') || 0;
        if (sl.getAttribute('data-oi-autoplay') === 'true' && iv >= 1000) timer = setInterval(function () { go(idx + 1); }, iv);
      }
      sl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-oi-prev], [data-oi-next], [data-oi-dot]');
        if (!b || !sl.contains(b)) return;
        e.preventDefault(); e.stopPropagation();
        if (b.hasAttribute('data-oi-dot')) go(+b.getAttribute('data-oi-dot'), true);
        else go(idx + (b.hasAttribute('data-oi-next') ? 1 : -1), true);
      }, true);
      var sx = null, sy = null;
      sl.addEventListener('pointerdown', function (e) { if (e.target.closest('button')) return; sx = e.clientX; sy = e.clientY; });
      sl.addEventListener('pointerup', function (e) {
        if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1), true);
      });
      sl.addEventListener('pointercancel', function () { sx = null; });
      var tx = null, ty = null;
      sl.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
      sl.addEventListener('touchend', function (e) {
        if (tx === null) return; var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty; tx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { sx = null; go(idx + (dx < 0 ? 1 : -1), true); }
      }, { passive: true });
      sl.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      sl.addEventListener('mouseleave', restart);
      window.addEventListener('resize', function () { paint(false); });
      paint(false);
      restart();
    });
  }
  // subfooter no pixel inteiro: a altura acumulada acima deixa o topo dele em y=...,7 e o texto/icones
  // rasterizam 1px abaixo do dele (que fica em ...,0). Margem < 1px, refeita quando o layout muda.
  // margem inline ORIGINAL da secao, gravada no 1o toque (os dois ajustes partem dela, nunca do ajuste anterior)
  function m0(s) { if (s.__clm0 === undefined) s.__clm0 = s.style.marginTop; s.style.marginTop = s.__clm0; return parseFloat(getComputedStyle(s).marginTop) || 0; }
  function snapSubfooter() {
    var s = document.querySelector('.shopify-section[id*="subfooter"]');
    if (!s) return;
    var base = m0(s);
    var t = s.getBoundingClientRect().top + window.scrollY, f = t - Math.floor(t);
    if (f > 0.02 && f < 0.98) s.style.marginTop = (base + 1 - f).toFixed(3) + 'px';
  }
  // fracao de pixel do topo de cada secao = a da pagina dele (tabela window.CL_FRAC gerada por cl_fractions.py):
  // alturas iguais + fracao diferente = conteudo rasterizado 1px deslocado. Margem extra < 1px por secao.
  function fracMatch() {
    var M = window.CL_FRAC, path = location.pathname.replace(/\/+$/, '') || '/';
    var T = M && M[path] && M[path][window.innerWidth >= 768 ? 'd' : 'm'];
    if (!T || /[?&]cl_nofrac=1/.test(location.search)) return false;
    var secs = [].filter.call(document.querySelectorAll('.shopify-section:not(.shopify-section .shopify-section)'),
      function (s) { return s.getBoundingClientRect().height >= 1; });
    if (secs.length !== T.length) return false;
    var bases = secs.map(m0);
    secs.forEach(function (s, i) {
      var pos = getComputedStyle(s).position;
      if (pos === 'fixed' || pos === 'absolute') return;
      var t = s.getBoundingClientRect().top + window.scrollY, f = t - Math.floor(t);
      var d = ((T[i] - f) % 1 + 1) % 1;
      if (d < 0.01 || d > 0.99) return;
      s.style.marginTop = (bases[i] + d).toFixed(3) + 'px';
    });
    return true;
  }
  function snapWatch() {
    var q = 0;
    var run = function () { if (q) return; q = requestAnimationFrame(function () { q = 0; if (!fracMatch()) snapSubfooter(); }); };
    if (window.ResizeObserver) new ResizeObserver(run).observe(document.body);
    window.addEventListener('load', run);
    run();
  }
  // Okendo: "Filtres" abre/fecha o painel (como o dele); marcar uma nota usa o filtro por estrelas do
  // cl-live.js (clique na barra do histograma). Captura: roda antes do handler herdado do cl-live.js.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cl-own] .oke-w-reviews-filterToggle');
    if (!t) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var w = t.closest('.oke-w-reviews') || t.closest('[data-cl-own]');
    var f = w && w.querySelector('.oke-w-filters');
    var open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    t.classList.toggle('oke-is-active', open);
    if (f) f.style.display = open ? '' : 'none';
  }, true);
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb.classList || !cb.classList.contains('oke-w-filterOption-checkbox') || !cb.closest('[data-cl-own]')) return;
    var n = parseInt((/(\d)/.exec(cb.getAttribute('name') || '') || [])[1], 10);
    var own = cb.closest('[data-cl-own]');
    own.querySelectorAll('.oke-w-filterOption-checkbox').forEach(function (x) { if (x !== cb) x.checked = false; });
    var bars = [].slice.call(own.querySelectorAll('.oke-w-breakdownModule-distribution-highlight'));
    var sel = bars.filter(function (b) { return b.classList.contains('oke-is-selected'); })[0];
    var bar = bars.filter(function (b) { var m = /(\d)\s*étoile/i.exec(b.getAttribute('aria-label') || ''); return m && +m[1] === n; })[0];
    // o histograma alterna: desmarcar = clicar na barra ativa; trocar = clicar na nova
    if (cb.checked) { if (bar && bar !== sel) bar.click(); }
    else if (sel) sel.click();
  });
  // contato: replica do widget de rastreio (build_track.py). Abas Order number / Tracking number; "Suivre"
  // leva ao app 17TRACK da loja (/apps/17TRACK; nota do operador 2026-10-14), com o numero de rastreio em ?nums=.
  document.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('[data-cl-track]');
    if (!w) return;
    var b = e.target.closest('button');
    if (!b) return;
    var pane = b.closest('[data-cl-track-pane]');
    var tabs = [].slice.call(pane.querySelectorAll('ul button'));
    var ti = tabs.indexOf(b);
    e.preventDefault();
    if (ti >= 0) {
      var want = ti === 0 ? 'order' : 'track';
      [].forEach.call(w.querySelectorAll('[data-cl-track-pane]'), function (p) { p.style.display = p.getAttribute('data-cl-track-pane') === want ? 'block' : 'none'; });
      return;
    }
    var ins = [].slice.call(pane.querySelectorAll('input'));
    var vals = ins.map(function (i) { return (i.value || '').trim(); });
    if (pane.getAttribute('data-cl-track-pane') === 'track') {
      if (!vals[0]) { ins[0].focus(); return; }
      location.href = 'https://r8tuag-ui.myshopify.com/apps/17TRACK?nums=' + encodeURIComponent(vals[0]);
    } else {
      if (!vals[0]) { ins[0].focus(); return; }
      if (ins[1] && !/@/.test(vals[1])) { ins[1].focus(); return; }
      location.href = 'https://r8tuag-ui.myshopify.com/apps/17TRACK';
    }
  });
  // secao DUPLA (dual.py): so a copia do viewport atual fica no DOM. A outra (display:none) duplicava ids e
  // botoes — o primeiro [aria-expanded] da secao caia na copia escondida e o clique nao fazia nada.
  // Os nos sao guardados (com listeners) e voltam no lugar quando o breakpoint muda.
  var dualEls = null;
  function dualSwap() {
    if (document.readyState === 'loading') return;
    if (!dualEls) {
      dualEls = [].slice.call(document.querySelectorAll('.cl-vd[data-cl-own], .cl-vm[data-cl-own]'));
      dualEls.forEach(function (el) { el.__ph = document.createComment('cl-dual'); el.parentNode.insertBefore(el.__ph, el); });
    }
    var desk = window.matchMedia('(min-width: 768px)').matches;
    dualEls.forEach(function (el) {
      var want = el.classList.contains('cl-vd') ? desk : !desk;
      if (want && !el.isConnected && el.__ph.parentNode) el.__ph.parentNode.insertBefore(el, el.__ph.nextSibling);
      else if (!want && el.isConnected) el.parentNode.removeChild(el);
    });
  }
  dualSwap();
  // a copia do outro viewport so entra no DOM na troca de breakpoint (desktop -> mobile no devtools, giro de tela):
  // ela NUNCA passou pelo boot -> sliders parados e <video data-src> sem src (retrabalho 2026-10-14: "grids/videos
  // estaticos no mobile"). Na troca: inicializa o que entrou (os motores sao idempotentes) e retoca os videos.
  try { window.matchMedia('(min-width: 768px)').addEventListener('change', function () { dualSwap(); videos(); carousels(); oiSliders(); setTimeout(function () { document.querySelectorAll('[data-cl-own] .flickity-viewport').forEach(function (v) { if (v._clcPaint) v._clcPaint(false); }); }, 50); }); } catch (e) {}
  function boot() { dualSwap(); videos(); carousels(); oiSliders(); snapWatch(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  // carrossel dentro de aba escondida mede 0: remede quando a aba aparece
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.tab-link')) setTimeout(function () { document.querySelectorAll('[data-cl-own] .flickity-viewport').forEach(function (v) { if (v._clcPaint) v._clcPaint(false); }); carousels(); }, 80); });
})();
